import script from "./produClassif.vue?vue&type=script&setup=true&lang=js"
export * from "./produClassif.vue?vue&type=script&setup=true&lang=js"

import "./produClassif.vue?vue&type=style&index=0&id=c877d334&lang=scss"

const __exports__ = script;

export default __exports__